import type { EpicArg } from 'Core/epics/common';

export default function retrySearch({ state }: EpicArg): void {
  if (state.search.retriesCount > 1) {
    window.location.reload();
  }
}
